/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import DocumentInfo from './DocumentInfo';

/**
 * The ExemptionDocuments model module.
 * @module model/ExemptionDocuments
 * @version 1.0.0
 */
class ExemptionDocuments {
    /**
     * Constructs a new <code>ExemptionDocuments</code>.
     * @alias module:model/ExemptionDocuments
     */
    constructor() { 
        
        ExemptionDocuments.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ExemptionDocuments</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ExemptionDocuments} obj Optional instance to populate.
     * @return {module:model/ExemptionDocuments} The populated <code>ExemptionDocuments</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ExemptionDocuments();

            if (data.hasOwnProperty('exemption_request')) {
                obj['exemption_request'] = DocumentInfo.constructFromObject(data['exemption_request']);
            }
            if (data.hasOwnProperty('work_life')) {
                obj['work_life'] = DocumentInfo.constructFromObject(data['work_life']);
            }
            if (data.hasOwnProperty('tasks')) {
                obj['tasks'] = DocumentInfo.constructFromObject(data['tasks']);
            }
            if (data.hasOwnProperty('affidavit')) {
                obj['affidavit'] = DocumentInfo.constructFromObject(data['affidavit']);
            }
            if (data.hasOwnProperty('economic_activity')) {
                obj['economic_activity'] = DocumentInfo.constructFromObject(data['economic_activity']);
            }
            if (data.hasOwnProperty('contribution')) {
                obj['contribution'] = DocumentInfo.constructFromObject(data['contribution']);
            }
            if (data.hasOwnProperty('fee')) {
                obj['fee'] = DocumentInfo.constructFromObject(data['fee']);
            }
            if (data.hasOwnProperty('model130')) {
                obj['model130'] = DocumentInfo.constructFromObject(data['model130']);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/DocumentInfo} exemption_request
 */
ExemptionDocuments.prototype['exemption_request'] = undefined;

/**
 * @member {module:model/DocumentInfo} work_life
 */
ExemptionDocuments.prototype['work_life'] = undefined;

/**
 * @member {module:model/DocumentInfo} tasks
 */
ExemptionDocuments.prototype['tasks'] = undefined;

/**
 * @member {module:model/DocumentInfo} affidavit
 */
ExemptionDocuments.prototype['affidavit'] = undefined;

/**
 * @member {module:model/DocumentInfo} economic_activity
 */
ExemptionDocuments.prototype['economic_activity'] = undefined;

/**
 * @member {module:model/DocumentInfo} contribution
 */
ExemptionDocuments.prototype['contribution'] = undefined;

/**
 * @member {module:model/DocumentInfo} fee
 */
ExemptionDocuments.prototype['fee'] = undefined;

/**
 * @member {module:model/DocumentInfo} model130
 */
ExemptionDocuments.prototype['model130'] = undefined;






export default ExemptionDocuments;

